module.exports = __webpack_public_path__ + "static/media/mile4.0ce5adcf.png";